import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { GridColDef, GridRowParams } from '@mui/x-data-grid-pro';
import { FormDialog } from '../../../form-dialog';
import { Box } from '../../../box';
import { Row } from '../../../row';
import { FormControl } from '../../../form-control/form-control';
import { Container } from '../../../container/container';
import { stringComparator } from '../../../../areas/search/utilities/sort-comparators';
import { Cell } from '../../../cell';
import { redirectToEntity } from '../../../../areas/search/utilities/redirect-to-entity';
import { useRowActions } from '../../../../areas/search/contextProviders/row-action-provider';
import { ICitizen } from './show-citizens-dialog';

export interface IShowCitizensDialogComponentProps {
  open: boolean;
  citizens: ICitizen[];
  onClose: () => void;
  isLoading: boolean;
}

export function ShowCitizensDialogComponent(props: IShowCitizensDialogComponentProps) {
  const { open, citizens, onClose, isLoading } = props;
  const rowActions = useRowActions();

  citizens
    .filter(x => !!x)
    .forEach(x => {
      // eslint-disable-next-line no-param-reassign
      x.id = x.citizenId;
    });
  function onConfirm() {
    onClose && onClose();
  }
  const columns: GridColDef[] = [
    {
      field: 'cpr',
      headerName: 'CPR-nr',
      sortComparator: stringComparator,
      valueGetter: ({ value }) => `${value.slice(0, 6)}-${value.slice(6)}`,
    },
    {
      field: 'fullName',
      headerName: 'Navn',
      description: '',
      flex: 1,
      // minWidth: 300,
      sortComparator: stringComparator,
    },
  ];

  function handleRowClick(params: GridRowParams) {
    redirectToEntity(params, rowActions, 'citizen', 'citizen');
  }
  return (
    <FormDialog open={open} title="Valgte borgere" confirmButtonText="Luk" onConfirmClick={onConfirm} maxWidth="lg" isValid>
      <FormControl fullWidth>
        <Container>
          <Box width="500px">
            <Row>
              <Cell size="full">
                <DataGridPro
                  loading={isLoading}
                  rows={citizens?.filter(x => !!x) || []}
                  columns={columns || []}
                  autoHeight
                  density="compact"
                  disableColumnMenu
                  pageSize={20}
                  onRowClick={handleRowClick}
                  pagination
                />
              </Cell>
            </Row>
          </Box>
        </Container>
      </FormControl>
    </FormDialog>
  );
}
